import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=07e2edcb&"
import script from "./Recorder.vue?vue&type=script&lang=js&"
export * from "./Recorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports